import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const isFraternalMember: AnswerPathTreeNode = {
  path: 'isFraternalMember',
  nodeId: NodeIds.insuredIsFraternalMember,
};
